import { useRef, useState, useContext } from "react";
import {
  Box,
  Grid,
  Select,
  MenuItem,
  Typography,
  FormControl,
} from "@mui/material";
import dayjs from "dayjs";
import { PiPrinterFill } from "react-icons/pi";
import { useReactToPrint } from "react-to-print";
// import { useLocation, useNavigate } from "react-router-dom";
//Srcs
import "../../Style/pagestyle.scss";
import { SelectDatePicker } from "../../Components/Include/SelectDatePicker/SelectDatePicker";
import { SelectMonthYearPicker } from "../../Components/Include/SelectDatePicker/SelectMonthYearPicker";
import { ButtonCreate, PageHeaderTitle } from "../../Utils/Component";
import { AuthContext } from "../../Context/AuthContext";
import AlertToPayInvoice from "../../Components/Report/AlertToPayInvoice";
import StudentByStatus from "../../Components/Report/StudentByStatus";
import InvoiceByPaymentStatus from "../../Components/Report/InvoiceByPaymentStatus";
import ScheduleByDay from "../../Components/Report/ScheduleByDay";
import PerformanceReport from "../../Components/Report/PerformanceReport";
import Expense from "../../Components/Report/Expense";
import {
  SelectCourse,
  SelectClass,
  SelectPerformanceType,
  SelectExpenseType,
} from "../../Components/Include/DynamicSelect/DynamicSelect";

export default function Report() {
  const { t } = useContext(AuthContext);

  const reportArray = [
    { title: t("report_pay_invoice"), value: "alertPayment" },
    { title: t("page_student"), value: "student" },
    { title: t("page_invoice"), value: "invoice" },
    { title: t("report_student_statistic"), value: "student-statistic" },
    { title: t("report_performance"), value: "performance" },
    { title: t("page_expense"), value: "expense" },
  ];
  const [type, setType] = useState({ id: "", title: "" });
  const reportTypeFromLocal = JSON.parse(
    localStorage.getItem("reportTypeFromLocal"),
  );
  const [reportType, setReportType] = useState(
    reportTypeFromLocal ?? "student",
  );

  //print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [studentStatus, setStudentStatus] = useState("All");
  const [paymentStatus, setPaymentStatus] = useState("All");
  const [groupFeeType, setGroupFeeType] = useState("All");
  const [courseVal, setCourseVal] = useState({ id: "", title: "" });
  const [classVal, setClassVal] = useState({ id: "", title: "" });
  const [performanceTypeVal, setPerformanceTypeVal] = useState({
    id: "",
    title: "",
  });
  const [filterDay, setFilterDay] = useState("Monday");
  const [filterMonth, setFilterMonth] = useState(dayjs());
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // console.log("fromDate::", fromDate);

  const handleReportType = (data) => {
    setReportType(data);
    if (data) {
      localStorage.setItem("reportTypeFromLocal", JSON.stringify(data));
    }
  };

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/other"}
        pageTitle={t("page_other")}
        detailTitle={t("page_report")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_report_type")}
            </Typography>
            <FormControl className={"text-field"} fullWidth size="small">
              <Select
                value={reportType}
                onChange={(e) => handleReportType(e.target.value)}
              >
                {reportArray.map((report) => (
                  <MenuItem value={report.value} key={report.title}>
                    {report.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {reportType === "performance" && (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("thead_class")}
              </Typography>

              <SelectClass
                className="text-field"
                buttonAdd={false}
                onChange={(val) => setClassVal(val || { id: "", title: "" })}
                value={classVal}
              />
            </Grid>
          )}

          {reportType === "performance" && (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("page_performance_type")}
              </Typography>

              <SelectPerformanceType
                className="text-field"
                buttonAdd={false}
                onChange={(val) =>
                  setPerformanceTypeVal(val || { id: "", title: "" })
                }
                value={performanceTypeVal}
              />
            </Grid>
          )}

          {reportType === "alertPayment" && (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("thead_alert_month")}
              </Typography>

              <SelectMonthYearPicker
                value={filterMonth}
                onChange={(val) => setFilterMonth(val)}
              />
            </Grid>
          )}

          {reportType === "student-statistic" && (
            <>
              <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
                <Typography className={t("class-name-text-field-title")}>
                  {t("thead_day")}
                </Typography>
                <FormControl className={"text-field"} fullWidth size="small">
                  <Select
                    value={filterDay}
                    onChange={(e) => setFilterDay(e.target.value)}
                  >
                    <MenuItem value={"Monday"}>Monday</MenuItem>
                    <MenuItem value={"Tuesday"}>Tuesday</MenuItem>
                    <MenuItem value={"Wednesday"}>Wednesday</MenuItem>
                    <MenuItem value={"Thursday"}>Thursday</MenuItem>
                    <MenuItem value={"Friday"}>Friday</MenuItem>
                    <MenuItem value={"Saturday"}>Saturday</MenuItem>
                    <MenuItem value={"Sunday"}>Sunday</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
                <Typography className={t("class-name-text-field-title")}>
                  {t("thead_course")}
                </Typography>
                <SelectCourse
                  className="text-field"
                  buttonAdd={false}
                  onChange={(val) => setCourseVal(val || { id: "", title: "" })}
                  value={courseVal}
                />
              </Grid>
            </>
          )}

          {reportType === "student" && (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("thead_status")}
              </Typography>
              <FormControl className={"text-field"} fullWidth size="small">
                <Select
                  value={studentStatus}
                  onChange={(e) => setStudentStatus(e.target.value)}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value={"studying"}>Studying</MenuItem>
                  <MenuItem value={"complete"}>Complete</MenuItem>
                  <MenuItem value={"dropout"}>Dropout</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}

          {reportType === "invoice" && (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
              <Typography className={t("class-name-text-field-title")}>
                {t("thead_status")}
              </Typography>
              <FormControl className={"text-field"} fullWidth size="small">
                <Select
                  value={paymentStatus}
                  onChange={(e) => setPaymentStatus(e.target.value)}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value={"Paid"}>Paid</MenuItem>
                  <MenuItem value={"Owe"}>Owe</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}

          {reportType === "invoice" && (
            <>
              <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
                <Typography className={t("class-name-text-field-title")}>
                  {t("thead_from_date")}
                </Typography>

                <SelectDatePicker
                  value={fromDate}
                  onChange={(val) => setFromDate(val)}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
                <Typography className={t("class-name-text-field-title")}>
                  {t("thead_to_date")}
                </Typography>

                <SelectDatePicker
                  value={toDate}
                  onChange={(val) => setToDate(val)}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
                <Typography className={t("class-name-text-field-title")}>
                  {t("page_group_fee")}
                </Typography>
                <FormControl className={"text-field"} fullWidth size="small">
                  <Select
                    value={groupFeeType}
                    onChange={(e) => setGroupFeeType(e.target.value)}
                  >
                    <MenuItem value="All">All</MenuItem>
                    {/* <MenuItem value={"DirectClass"}>Direct Class</MenuItem>
                    <MenuItem value={"OnlineClass"}>Online Class</MenuItem>
                    <MenuItem value={"Book"}>Book</MenuItem>
                    <MenuItem value={"Instrument"}>Instrument</MenuItem> */}
                    <MenuItem value={"Piano"}>Piano</MenuItem>
                    <MenuItem value={"Guitar"}>Guitar, violin</MenuItem>
                    <MenuItem value={"Drum"}>Drum, Bass</MenuItem>
                    <MenuItem value={"OnlineClass"}>Online Class</MenuItem>
                    <MenuItem value={"Book"}>Book</MenuItem>
                    <MenuItem value={"Instrument"}>Instrument</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}

          {reportType === "expense" && (
            <>
              <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
                <Typography className={t("class-name-text-field-title")}>
                  {t("thead_from_date")}
                </Typography>

                <SelectDatePicker
                  value={fromDate}
                  onChange={(val) => setFromDate(val)}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
                <Typography className={t("class-name-text-field-title")}>
                  {t("thead_to_date")}
                </Typography>

                <SelectDatePicker
                  value={toDate}
                  onChange={(val) => setToDate(val)}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
                <Typography className={t("class-name-text-field-title")}>
                  {t("thead_type")}
                </Typography>
                <SelectExpenseType
                  buttonAdd={false}
                  value={type}
                  onChange={(val) => setType(val)}
                  className="text-field"
                />
              </Grid>
            </>
          )}

          {reportType === "alertPayment" ? (
            <Grid item xs={12} sm={12} md={4} lg={6} xl={8}>
              <ButtonCreate
                handleOpen={handlePrint}
                classBtn={"btn-create"}
                classIcon={"icon-add"}
                title={t("print")}
                icon={<PiPrinterFill className={"icon-add"} />}
              />
            </Grid>
          ) : reportType === "invoice" ? (
            <Grid item xs={6} sm={6} md={4} lg={9} xl={2}>
              <ButtonCreate
                handleOpen={handlePrint}
                classBtn={"btn-create"}
                classIcon={"icon-add"}
                title={t("print")}
                icon={<PiPrinterFill className={"icon-add"} />}
              />
            </Grid>
          ) : reportType === "expense" ? (
            <Grid item xs={12} sm={12} md={8} lg={12} xl={4}>
              <ButtonCreate
                handleOpen={handlePrint}
                classBtn={"btn-create"}
                classIcon={"icon-add"}
                title={t("print")}
                icon={<PiPrinterFill className={"icon-add"} />}
              />
            </Grid>
          ) : reportType === "student" ? (
            <Grid item xs={12} sm={12} md={4} lg={6} xl={8}>
              <ButtonCreate
                handleOpen={handlePrint}
                classBtn={"btn-create"}
                classIcon={"icon-add"}
                title={t("print")}
                icon={<PiPrinterFill className={"icon-add"} />}
              />
            </Grid>
          ) : (
            <Grid item xs={6} sm={6} md={12} lg={3} xl={6}>
              <ButtonCreate
                handleOpen={handlePrint}
                classBtn={"btn-create"}
                classIcon={"icon-add"}
                title={t("print")}
                icon={<PiPrinterFill className={"icon-add"} />}
              />
            </Grid>
          )}
        </Grid>
      </Box>

      <Box className="report-container">
        {reportType === "alertPayment" && (
          <AlertToPayInvoice componentRef={componentRef} date={filterMonth} />
        )}

        {reportType === "student" && (
          <StudentByStatus componentRef={componentRef} status={studentStatus} />
        )}

        {reportType === "invoice" && (
          <InvoiceByPaymentStatus
            componentRef={componentRef}
            paymentStatus={paymentStatus}
            fromDate={fromDate}
            toDate={toDate}
            groupFeeType={groupFeeType}
          />
        )}

        {reportType === "student-statistic" && (
          <ScheduleByDay
            componentRef={componentRef}
            day={filterDay}
            courseId={courseVal?.id}
          />
        )}

        {reportType === "performance" && (
          <PerformanceReport
            componentRef={componentRef}
            classId={classVal?.id}
            performanceTypeId={performanceTypeVal?.id}
          />
        )}

        {reportType === "expense" && (
          <Expense
            componentRef={componentRef}
            fromDate={fromDate}
            toDate={toDate}
            type={type?.id}
          />
        )}
      </Box>
    </div>
  );
}
